import React from "react";
import { Link } from "react-router-dom";
import "./Faq.css";

const Faq = () => (
  <section className="thas-faq" id="vanliga-fragor" aria-labelledby="faq-heading">
    <div className="site-container thas-faq-grid">
      <div className="thas-faq-intro">
        <p className="site-eyebrow">Bra att veta innan vi börjar</p>
        <h2 id="faq-heading">Vanliga frågor<br />om våra tjänster.</h2>
        <p>Här hittar du svar om paket, priser och hur du tar nästa steg.</p>
        <Link className="site-text-link" to="/#contact">Ställ din fråga <span aria-hidden="true">↗</span></Link>
      </div>
      <div className="thas-faq-answers">
        <details>
          <summary>Vad kostar bokföringspaketen?</summary>
          <div className="thas-faq-answer">
            <p>Paket 1 kostar 499 kr/månad för 0–20 verifikationer per månad. Paket 2 kostar 749 kr för 21–30 och Paket 3 kostar 999 kr för 31–40. Alla priser anges exkl. moms.</p>
            <Link className="site-text-link" to="/#priser">Jämför paket och priser <span aria-hidden="true">↗</span></Link>
          </div>
        </details>
        <details>
          <summary>Vad ingår i ett bokföringspaket?</summary>
          <div className="thas-faq-answer">
            <p>Alla paket omfattar löpande bokföring, momsdeklarationer, lönehantering för en anställd samt support via telefon och e-post. Vi går tillsammans igenom vilket upplägg som passar din verksamhet.</p>
          </div>
        </details>
        <details>
          <summary>Vad är skillnaden mellan 499 kr/månad och 499 kr/tim?</summary>
          <div className="thas-faq-answer">
            <p>499 kr/månad är priset för vårt minsta bokföringspaket. 499 kr/tim är timpriset för tilläggstjänster inom bokslut, årsredovisning och deklarationer. Momsdeklarationer ingår redan i bokföringspaketen. Vi kommer överens om omfattningen innan arbetet börjar. Samtliga priser är exkl. moms.</p>
          </div>
        </details>
        <details>
          <summary>Kan jag få hjälp med löner för fler anställda?</summary>
          <div className="thas-faq-answer">
            <p>Ja. Lönehantering för en anställd ingår i paketet. Extra löner kostar 149 kr per person och månad, exkl. moms.</p>
            <Link className="site-text-link" to="/LÖNEADMINISTRATION">Läs om löneadministration <span aria-hidden="true">↗</span></Link>
          </div>
        </details>
        <details>
          <summary>Hur börjar jag samarbeta med THAS?</summary>
          <div className="thas-faq-answer">
            <p>Kontakta oss och berätta kort om företaget, mängden underlag och vad du behöver hjälp med. Vi går igenom behov, omfattning och pris tillsammans innan uppdraget börjar.</p>
            <Link className="site-text-link" to="/#contact">Kontakta THAS Redovisning <span aria-hidden="true">↗</span></Link>
          </div>
        </details>
      </div>
    </div>
  </section>
);

export default Faq;
